import React from 'react';
import { Row, Col } from 'antd';
import { Input, PhoneInput } from '@/components/form';

export const PersonalDetailsStep: React.FC = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Personal Details</h3>
      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <Input
            name="firstName"
            label="First Name"
            placeholder="Enter first name"
            required
          />
        </Col>

        <Col xs={24} sm={12}>
          <Input
            name="lastName"
            label="Last Name"
            placeholder="Enter last name"
            required
          />
        </Col>

        <Col xs={24} sm={12}>
          <Input
            name="email"
            label="Email"
            placeholder="email@victoriansliders.co.uk"
            required
            rules={[
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          />
        </Col>

        <Col xs={24} sm={12}>
          <PhoneInput
            name="phone"
            label="Phone"
            placeholder="Enter phone number"
          />
        </Col>
      </Row>
    </div>
  );
};

export default PersonalDetailsStep;
